import React, { useState } from 'react';
import { STRATEGY_TABS } from '../lib/constants';
import { Chip } from '../components/ui';
import Plan from './Plan';
import Decisions from './Decisions';
import { useStore } from '../state/store';
import { orgTimeTargets, planNeedsSetup } from '../lib/orgPlan';

/** Strategy hub — locked allocation, map, decisions & exceptions. */
export default function Strategy({ go }) {
  const [tab, setTab] = useState('plan');
  const { state } = useStore();
  const timeTargets = orgTimeTargets(state);
  const needsSetup = planNeedsSetup(state);

  return (
    <>
      <div className="page-head">
        <div className="row wrap" style={{ gap: 8 }}>
          <h2>Strategy</h2>
          {!needsSetup &&
            STRATEGY_TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`btn sm ${tab === t.key ? 'primary' : 'ghost'}`}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </button>
            ))}
        </div>
        {!needsSetup && (
          <div className="sub row wrap" style={{ gap: 8, marginTop: 8 }}>
            <span className="dim tiny">{timeTargets.length ? 'Allocation locked' : 'No allocation yet'}</span>
            {timeTargets.map((t) => (
              <Chip key={t.key}>
                {t.label} {t.target}%
              </Chip>
            ))}
          </div>
        )}
      </div>
      {(needsSetup || tab === 'plan') && <Plan go={go} />}
      {!needsSetup && tab === 'decisions' && <Decisions go={go} />}
    </>
  );
}
